import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type SessionContextService from 'tio-employee/services/session-context';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type TasProgramInstanceModel from 'tio-data/models/tas-program-instance';
import type TasUnifiedInstitutionModel from 'tio-data/models/tas-unified-institution';
import type TasGroupModel from 'tio-data/models/tas-group';

export default class AuthenticatedTasProgramsNewRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;

  async model() {
    // @ts-expect-error seems like a bug or is the model a template?
    const { programInstance } = this.modelFor('authenticated.tas.programs');

    let selectedSchool: TasUnifiedInstitutionModel | undefined;

    try {
      const tasInstitutionId = programInstance.fields['TAS_INSTITUTION_ID']?.values?.[0];
      const dapipInstitutionId = programInstance.fields['DAPIP_INSTITUTION_ID']?.values?.[0];

      if (tasInstitutionId || dapipInstitutionId) {
        const filter: Record<string, string | number | undefined> = {
          'tas-program-template': programInstance.tasProgramTemplate.id,
        };

        if (dapipInstitutionId) {
          filter['dapip-id'] = dapipInstitutionId;
        }

        if (tasInstitutionId) {
          filter['institution-id'] = tasInstitutionId;
        }
        const results = await this.store.query<TasUnifiedInstitutionModel>(
          'tas-unified-institution',
          {
            // @ts-expect-error: type filter
            filter,
            page: { limit: 1, offset: 0 },
          }
        );
        selectedSchool = results[0];
      }
    } catch (e) {
      console.error('Error attempting to load previously selected school', e);
    }

    // tasGroups and activeInstances will be needed for check of mutually exclusive groups
    // and in progress instances of the current template
    const tasGroups = await this.store.query<TasGroupModel>('tas-group', {
      filter: {
        company: this.sessionContext.currentEmployee.company.id,
        flavor: 'TAS.GroupFlavor.MUTUALLY_EXCLUSIVE',
      },
      include: 'tas-groupings.tas-program-template',
    });

    const activeInstances = await this.store.query<TasProgramInstanceModel>(
      'tas-program-instance',
      {
        filter: { employee: this.sessionContext.currentEmployee.id, active: true },
        include: 'tas-program-template',
      }
    );

    return {
      activeInstances: activeInstances,
      programInstance: programInstance,
      selectedSchool: selectedSchool,
      tasGroups: tasGroups,
    };
  }
}
